








































































import {Vue, Prop, Component, Watch } from 'vue-property-decorator';
import OrganizationPassengerPage from '@/components/Organization/OrganizationPassengerPage.vue';
import Passenger from '../Passenger/models/Passenger';
import AddPassengerToPassengerGroupDialog from '@/components/Organization/AddPassengerToPassengerGroup/AddPassengerToPassengerGroupDialog.vue';
import { IPassengerGroupWithPassengers } from '@/typings/timit';
import PassengerDestination from '../Passenger/models/PassengerDestination';
import Destination from '../Passenger/models/Destination';
import Routes from '@/Routes';
import RemovePassengerFromGroupConfirmationDialog from '../Organization/RemovePassengerFromGroupConfirmationDialog.vue';

interface IPassengerTableProperties {
  id: number;
  name: string;
  destination: string;
  phone: string;
  groups: string;
  transportationPermissionCount: number;
  inactive: boolean;
}

@Component({
    components: {
      OrganizationPassengerPage,
      AddPassengerToPassengerGroupDialog,
      RemovePassengerFromGroupConfirmationDialog,
    }
})
export default class PassengerGroupPassengers extends Vue {
  
  selectedPassenger: Passenger | null = null;
  openCreateNewPassengerDialog = false;
  openAddPassengerToPassengerGroupDialog: boolean = false;
  openRemoveConfirmationModal: boolean = false;
  // passengerGroup: IPassengerGroupWithPassengers | null = null;
  search = '';
  pagination: any = {
    sortBy: 'name',
    descending: true,
    rowsPerPage: 25,
  }

  async created() {
    const passengerGroupId = parseInt(this.$route.params.passengerGroupId, 10);
    const result = await this.$store.dispatch('organization/getPassengerGroupWithPassengers', 
    {
     params: {
       id: passengerGroupId
     }
    });
  }

  get passengerGroup(): IPassengerGroupWithPassengers {
    return this.$store.state.organization.selectedPassengerGroup;
  }

  get passengers(): IPassengerTableProperties[] {
    let passengers: IPassengerTableProperties[] = [];
    
    if (!this.passengerGroup) {
      return passengers;
    }

    passengers = this.passengerGroup.passengerGroupPassengers.map(p => ({
      id: p.id,
      name: p.name,
      destination: this.getMainDestination(p.passengerDestinations),
      phone: p.phone,
      groups: p.groups,
      transportationPermissionCount: p.transportationPermissionCount,
      inactive: p.inactive,
    }));

    if (this.showOnlyActivePassengers) {
      passengers = passengers.filter(p => !p.inactive);
    }

    return passengers;
  }

  get passengerGroupId() {
    return parseInt(this.$route.params.passengerGroupId, 10) ;
  }

  get headers(): any[] {

    return [
      { 
        text: this.$t('passenger.prop.name.label', 'Name'), 
        value: 'name',
        sortable: true,
        align: 'left'
      },
      { 
        text: this.$t('passenger.prop.destinations.main', 'Main Destination'), 
        value: 'destination',
        sortable: true,
        align: 'left'
      },
      { 
        text: this.$t('passenger.prop.phoneNumbers.label', 'Phone numbers'), 
        value: 'phone',
        sortable: true,
        align: 'left'
      },
      { 
        text: this.$t('passenger.prop.tags.label', 'Tags'), 
        value: 'groups',
        sortable: true,
        align: 'left'
      },
      { 
        text: this.$t('passenger.prop.transportationPermissions.label', 'Transportation permissions'), 
        value: 'transportationPermissionCount',
        sortable: true,
        align: 'left'
      },
      { 
        text: '',
        sortable: false,
        align: 'right'
      }
    ];
  }

  get showOnlyActivePassengers(): boolean {
    return this.$store.state.passenger.showOnlyActivePassengers;
  }

  set showOnlyActivePassengers(value: boolean) {
    this.$store.commit("passenger/changeShowActivePassengers", value);
  }


  getMainDestination(destinations: PassengerDestination[]) {
    if (!destinations || destinations.length === 0) {
      return '';
    }
    const firstDestination = destinations.find(d => d);
    const storeDestination = (this.$store.state.destination.destinations as Destination[])
      .find(d => d.id === firstDestination.destinationId);
    return storeDestination ? storeDestination.alias || storeDestination.address : '';
  }

  createNewPassenger() {
    this.selectedPassenger = new Passenger(null);
    this.selectedPassenger.organizationId = this.$route.params.organizationId;
    this.selectedPassenger.transportationPermissionRequired = this.$store.getters['organization/organizationRequirePtpByDefault'](this.selectedPassenger.organizationId);

    this.openCreateNewPassengerDialog = true;
  }

  closeCreateNewPassengerDialog() {
    this.openCreateNewPassengerDialog = false;
    this.selectedPassenger = null;
  }

  closeAddPassengerToPassengerGroupDialog() {
    this.openAddPassengerToPassengerGroupDialog = false;
  }

  openPassengerDetails(passenger: IPassengerTableProperties) {
    this.selectedPassenger = this.passengerGroup.passengerGroupPassengers.find(p => p.id === passenger.id);
    this.$router.push({
      name: Routes.editPassengerRoute.name, 
      params: { 
        passengerId: this.selectedPassenger.id.toString(),
      }
    })
    // this.dialog = true;
  }

  openRemoveModal(passenger: IPassengerTableProperties) {
    this.selectedPassenger = this.passengerGroup.passengerGroupPassengers.find(p => p.id === passenger.id);
    this.openRemoveConfirmationModal = true;
  }

  closeRemoveModal() {
    this.openRemoveConfirmationModal = false;
    this.selectedPassenger = null;
  }

  removePassengerFromGroup(passenger: Passenger) {
    const index = this.passengerGroup.passengerGroupPassengers.indexOf(passenger);
    this.passengerGroup.passengerGroupPassengers.splice(index, 1);
    this.closeRemoveModal();
  }

}
